
// import './Files.scss'
import { SingleUploadImageDataType } from "../../commonTypes/fileManagerTypes";
import {  deleteIcon } from "../../assets/images";
import PdfPreviewWithApi from "../commons/MultiPreviewWithApi/PdfPreviewWithApi";

type AppProps = {
  resetImageUrl: () => void;
  previewUrl: string;
  removeFile: () => void;
  imageDetails: SingleUploadImageDataType;
};

const HelpModuleImagePreview = ({
  previewUrl,
  resetImageUrl,
  removeFile,
  imageDetails,
}: AppProps) => {
  return (
    <div>
      <div
        className="mt-2 mb-2"
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        <span
          onClick={() => removeFile()}
          style={{
            cursor: "pointer",
            border: "none",
            color: "#dd4433",
            alignItems: "center",
            fontSize: "15px",
          }}
        >
          Delete File
          <img src={deleteIcon} style={{ padding: "0 5px" }} />
        </span>
      </div>
      {imageDetails?.fileType === "application/msword" ||
      imageDetails?.fileType === "application/vnd.ms-excel" ||
      imageDetails?.fileType ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
      imageDetails?.fileType ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
      imageDetails?.fileType ===
        "application/vnd.openxmlformats-officedocument.presentationml.presentation" ||
      imageDetails?.fileType === "application/vnd.ms-powerpoint" ? (
        previewUrl && (
          <iframe
            src={`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
              previewUrl
            )}`}
            width="100%"
            height="400px"
          />
        )
      ) : imageDetails?.fileType === "application/pdf" ? (
        <PdfPreviewWithApi imageDetails={previewUrl} />
      ) : (
        <img
          width="100%"
          src={previewUrl}
          alt="url"
        />
      )}
    </div>
  );
};

export default HelpModuleImagePreview;